import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import Link from '../../Link';

import { useThemeFlag } from '../../../../base/ThemeProvider';

import Trash from '../../icons/Trash';
import Delete from '../../icons/Delete';

import FileUploadFinish from '../../icons/FileUploadFinish';

import styles from '../FileUploader.module.scss';

const cx = classNames.bind(styles);

const Uploaded = ({ onDelete, title, fileName, className }) => {
  const fileUploaderClasses = cx(
    styles['file-uploader'],
    styles['file-uploader--with-subtitle'],
    className
  );
  const newButtonsEnabled = useThemeFlag('newButtons');
  const buttonClasses = cx(
    styles[
      newButtonsEnabled
        ? 'file-uploader__delete-link'
        : 'file-uploader__button--delete'
    ]
  );

  const deleteIcon = newButtonsEnabled ? (
    <Delete className={styles['file-uploader__button-icon']} />
  ) : (
    <Trash className={styles['file-uploader__button-icon']} />
  );

  return (
    <div data-cy="fileUploaderInitialState" className={fileUploaderClasses}>
      <div className={styles['file-uploader__row']}>
        <div className={styles['file-uploader__content']}>
          <div>
            <FileUploadFinish className={styles['file-uploader__icon']} />
          </div>
          <div className={styles['file-uploader__title']}>{title}</div>
          <div
            className={cx(
              styles['file-uploader__documentName'],
              styles['file-uploader__documentName--desktop']
            )}
          >
            {fileName}
          </div>
        </div>
        {!newButtonsEnabled && (
          <button
            type="button"
            onClick={onDelete}
            data-cy="fileUploaderDelete"
            className={buttonClasses}
          >
            <Trash className={styles['file-uploader__button-icon']} />
            {trans('document-upload.delete')}
          </button>
        )}
        {newButtonsEnabled && (
          <Link
            onClick={onDelete}
            className={buttonClasses}
            renderIcon={() => deleteIcon}
          >
            {trans('document-upload.delete')}
          </Link>
        )}
      </div>
      <div className={styles['file-uploader__row']}>
        <div
          className={cx(
            styles['file-uploader__documentName'],
            styles['file-uploader__documentName--mobile']
          )}
        >
          {fileName}
        </div>
      </div>
    </div>
  );
};

Uploaded.propTypes = {
  title: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired
};

export default Uploaded;
